<div class="form-container" [ngClass]="{ aumPreview: mode <= 1, aumPrint: mode <= 0 }">
    <form [formGroup]="form">
        <div formArrayName="fliSelectors" cdkDropList (cdkDropListDropped)="drop($event)">
            <div
                class="notesFliCompontent"
                *ngFor="let field of form.get('fliSelectors')['controls']; let fliSelectionIndex = index"
                [ngClass]="{ aumPreview: viewMode <= 1 }"
            >
                <div [formGroupName]="fliSelectionIndex" cdkDrag [cdkDragDisabled]="hasUnselectedFlis">
                    <div class="form-group form-fields-card form-fields">
                        <div *ngIf="mode === 2" class="input-wrapper">
                            <input
                                hamSimpleDropDown
                                [options]="getSelectionOptions(fliSelectionIndex)"
                                [optionKeys]="[propertyOfFliOptionsToDisplay]"
                                returnKey="caption"
                                [returnObject]="true"
                                [placeholder]="'aumico_notes_fli_selection_placeholder' | i18next"
                                [multiple]="false"
                                [formControl]="field['controls']['fli']"
                                (selectionChange)="onSelectionChanged($event, fliSelectionIndex)"
                                (clear)="openShowFliClearanceConfirmationDialog(fliSelectionIndex)"
                            />
                        </div>
                        <h4 *ngIf="mode <= 0">
                            <div *ngIf="isFliSelectedToShowReference(field)">
                                {{ printIndex }}.{{ fliSelectionIndex + 1 }}
                                {{ field['controls']['fli'].value.name }}
                            </div>
                        </h4>
                        <div class="form-fields">
                            <span
                                *ngIf="editable && mode === 2"
                                class="ham-icon numbering-icon"
                                [ngClass]="{
                                on: 
                                    tableNumbers != null && 
                                    tableNumbers.length > getTableNumberIndex(fliSelectionIndex) &&  
                                    tableNumbers[getTableNumberIndex(fliSelectionIndex)] != null &&
                                    tableNumbers[getTableNumberIndex(fliSelectionIndex)] !== '',
                                disabled: selectedFlis === undefined || selectedFlis.size === 0 || selectedFlis.get(fliSelectionIndex) == null || selectedFlis.get(fliSelectionIndex)?.accounts == null || selectedFlis.get(fliSelectionIndex)?.accounts.length === 0 || selectedFlis.get(fliSelectionIndex)?.accounts?.[0]?.accountName == null || selectedFlis.get(fliSelectionIndex)?.accounts?.[0]?.accountName === ''
                            }"
                                (click)="
                                onAddNumberToggleChange(
                                    !(tableNumbers?.[getTableNumberIndex(fliSelectionIndex)] != null &&
                                    tableNumbers?.[getTableNumberIndex(fliSelectionIndex)] !== ''),
                                    fliSelectionIndex
                                );
                                setNumberingToFli(!(tableNumbers?.[getTableNumberIndex(fliSelectionIndex)] != null &&
                                tableNumbers?.[getTableNumberIndex(fliSelectionIndex)] !== ''), fliSelectionIndex)
                            "
                            >
                                <i class="ordered-list-outline-icon"></i>
                            </span>

                            <span *ngIf="editable && mode === 2">
                                <span
                                    class="remove-icon"
                                    hamIconShapes
                                    variant="transparent"
                                    icon="assets/hamIcons/minus-outline.svg"
                                    size="xs"
                                    (click)="openShowFliClearanceConfirmationDialog(fliSelectionIndex)"
                                >
                                </span>
                            </span>
                        </div>
                    </div>

                    <fli-component-table
                        *ngIf="isFliSelected(fliSelectionIndex)"
                        [selectedFliName]="resolveCaption(field?.['controls']?.['fli']?.value?.caption)"
                        [textTitle]="resolveCaption(field?.['controls']?.['fli']?.value?.caption)"
                        [currentDate]="getCurrentDateForFli(field?.['controls']?.['fli']?.value)"
                        [previousDate]="getPreviousDateForFli(field?.['controls']?.['fli']?.value)"
                        [data]="getMatchingAccounts(fliSelectionIndex)"
                        [editable]="editable"
                        [language]="language"
                        [viewMode]="viewMode"
                        [hasFootnotes]="hasFootnotes"
                        [savedFootnote]="fliData?.footnotes?.[fliSelectionIndex]"
                        (formChange)="onFormChange($event, fliSelectionIndex)"
                        [totalRowText]="getTotalRowTextOfFli(fliSelectionIndex)"
                        [todoHighlight]="highlightTodos"
                        [tableNumber]="tableNumbers?.[getTableNumberIndex(fliSelectionIndex)]"
                        [fxState]="fxCurrencyDisplay"
                        [fxEnabled]="fxNotesContext != null"
                        [fliFxStamps]="fliFxStamps"
                        [functionalCurrency]="fxNotesContext?.functionalCurrency ?? ''"
                        [displayCurrency]="fxNotesContext?.displayCurrency ?? ''"
                    >
                        <span
                            *ngIf="mode === 2"
                            cdkDragHandle
                            [cdkDragHandleDisabled]="hasUnselectedFlis"
                            class="ham-icon drag-icon"
                            [class.drag-disabled]="hasUnselectedFlis"
                            [hamTooltip]="
                                hasUnselectedFlis ? ('aumico_notes_fli_drag_disabled_tooltip' | i18next) : null
                            "
                        >
                            <i class="dots-grid-icon"></i>
                        </span>
                    </fli-component-table>
                </div>
                <div class="add-component-section">
                    <div class="line"></div>
                    <ham-button
                        icon="assets/hamIcons/circle-plus.svg"
                        type="submit"
                        variant="white-round"
                        (click)="addItem(fliSelectionIndex)"
                    >
                        {{ 'aumico_notes_add_more_fli' | i18next }}
                    </ham-button>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="add-component-section" *ngIf="form.get('fliSelectors')['controls']?.length === 0">
    <div class="line"></div>
    <ham-button icon="assets/hamIcons/circle-plus.svg" type="submit" variant="white-round" (click)="addItem(0)">
        {{ 'aumico_notes_add_more_fli' | i18next }}
    </ham-button>
    <div class="line"></div>
</div>

<ham-confirm-decline-modal
    *ngIf="showFliClearanceConfirmationDialog"
    (cancel)="onCancelFliClearanceConfirmationDialog()"
    (action)="clearFliSelection()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_notes_fli_component_remove_fli_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
